module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.flipY()
      }
    }
  }, [_c('i', {
    staticClass: "icon-flip-vertical"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61f1d679","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/buttons/flipy.vue
// module id = 289
// module chunks = 0